import React from 'react'
import { Client } from '../imgs/imgs';
import Repeated from './Repeated';
import { Element } from 'react-scroll';

const Service = () => {
    
  return (
    <Element name="service">
    <Repeated imgName={Client} flexType='flex-col-reverse md:flex-row-reverse' bg='bg-white' title='Our Service' description="We're dedicated to providing top-notch driver education, placing safety as our top priority. Our meticulously designed program not only teaches essential driving skills but also cultivates confidence and responsibility. Tailored to individual needs, our experienced instructors create a supportive environment, emphasizing clarity and thoroughness in every lesson. With a focus on defensive driving, traffic laws, and real-life situations, we equip our clients for safe road navigation. Beyond just teaching driving, we aim to nurture responsible, conscientious drivers for life. Join us for a journey towards safe and confident driving." />
    </Element>
  )
}

export default Service








